import { AIBSourceApplication } from '../../enum/payment-aib';

export interface BankAibMID {
  merchantId: number;
  storeId: string;
  connectSharedSecret: string;
  restApiKey: string;
  restApiSecret: string;
  currency?: string;
  source: AIBSourceApplication;
}
